import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref } from 'vue'

import ProfilePicture, { ProfilePictureSizes } from './ProfilePicture.vue'
import {
  updatePopupProfile,
  loadCachedPopupProfile,
  createPopupProfile,
} from '@/popup/utils/profiles'
import { UpAddress, EoaAddress, PopupProfile } from '@/shared/models/Profile'
import { logError } from '@/shared/logger'

type Props = {
  size: ProfilePictureSizes
  address?: UpAddress | EoaAddress
  truncateNameLength?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePictureCached',
  props: {
    size: { default: 'small' },
    address: { default: undefined },
    truncateNameLength: { default: 10 }
  },
  setup(__props: any) {

const props = __props

const popupProfile = ref<PopupProfile | undefined | null>()

onMounted(async () => {
  if (props.address) {
    try {
      const profile = await loadCachedPopupProfile(props.address)
      if (!profile) {
        popupProfile.value = await createPopupProfile(props.address)
        return
      }
      popupProfile.value = profile?.isOwner
        ? profile
        : await updatePopupProfile(profile)
    } catch (err) {
      logError(`Error while mounting ProfilePictureCached:`, err)
      popupProfile.value = {
        temporary: { address: props.address },
        address: props.address,
      }
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (popupProfile.value !== null)
    ? (_openBlock(), _createBlock(ProfilePicture, {
        key: 0,
        size: _ctx.size,
        "frontend-profile": popupProfile.value?.temporary || popupProfile.value?.saved,
        "with-identicon": 
      !!popupProfile.value?.temporary?.verification?.data ||
      !!popupProfile.value?.saved?.verification?.data
    ,
        "with-name": true,
        "truncate-name-length": _ctx.truncateNameLength
      }, null, 8 /* PROPS */, ["size", "frontend-profile", "with-identicon", "truncate-name-length"]))
    : _createCommentVNode("v-if", true)
}
}

})